
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner-resources/[category]",
      function () {
        return require("private-next-pages/partner-resources/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner-resources/[category]"])
      });
    }
  